import { menuItemVariants as e, menuPopupVariants as t } from "./menu.styles.js";
import { MenuPrimitives as n } from "./menu.js";
import { AdaptiveMenu as r } from "./adaptive-menu.js";
//#region src/menu/index.ts
var i = Object.assign(r, n);
//#endregion
export { r as AdaptiveMenu, i as Menu, e as menuItemVariants, t as menuPopupVariants };
